/**
 *  The type of the action which signals that the keyboard shortcuts should be initialized.
 */
export const INIT_KEYBOARD_SHORTCUTS = 'INIT_KEYBOARD_SHORTCUTS';
/**
 * The type of the action which signals that a keyboard shortcut should be registered.
 */
export const REGISTER_KEYBOARD_SHORTCUT = 'REGISTER_KEYBOARD_SHORTCUT';
/**
 * The type of the action which signals that a keyboard shortcut should be unregistered.
 */
export const UNREGISTER_KEYBOARD_SHORTCUT = 'UNREGISTER_KEYBOARD_SHORTCUT';
/**
 * The type of the action which signals that a keyboard shortcut should be enabled.
 */
export const ENABLE_KEYBOARD_SHORTCUTS = 'ENABLE_KEYBOARD_SHORTCUTS';
/**
 * The type of the action which signals that a keyboard shortcut should be disabled.
 */
export const DISABLE_KEYBOARD_SHORTCUTS = 'DISABLE_KEYBOARD_SHORTCUTS';
